import mitt from 'mitt'

import type { Emitter, EventType } from 'mitt'

const emitter = mitt()

export function useEventBus<T extends Record<EventType, any>>() {
  return emitter as Emitter<T>
}
